<template>
    <div class="training-create-container" >
        <div class="button-container" @click.stop="open()">
            <slot name="button">
                test
            </slot>
        </div>
        <div class="create-modal" v-if="showModal" v-click-outside="close">
            <slot name="content">
                    <div class="items" >
                        <div 
                        class="item"
                        v-for="(item, index) in items"
                        @click="$emit('selectItem', item)"
                        >
                            <div class="icon">
                                <component :is="iconMap[item.key] ? iconMap[item.key]: 'documentTrainingSVG'" />
                            </div>
                            <div class="title">
                                {{ toLocal(item.value) }}
                            </div>
                            <div class="description">

                            </div>
                        </div>
                    </div>
            </slot>
        </div>

    </div>
</template>
<script>
import DocumentFolderSVG from "@/assets/images/icons/documentFolder.svg?inline";
import LiveTrainingSVG from "@/assets/images/icons/live_training.svg?inline";
import TrainingSVG from "@/assets/images/icons/e-training.svg?inline";
import InteractiveTrainingSVG from "@/assets/images/icons/interactive_training.svg?inline";
import documentTrainingSVG from "@/assets/images/icons/documentTraining.svg?inline";
import AttestingSVG from "@/assets/images/icons/attesting_training.svg?inline";
export default {
    name: 'TrainingCreateModal',
    props:{
        items:{
            type: Array
        }
    },
    components:{
        DocumentFolderSVG,
        LiveTrainingSVG,
        TrainingSVG,
        InteractiveTrainingSVG,
        documentTrainingSVG,
        AttestingSVG,
    },
    data() {
        return {
            showModal:false,
            clickOutsideEnabled: false,
            iconMap:{
                training_group: 'DocumentFolderSVG',
                physical: 'LiveTrainingSVG',
                training: 'TrainingSVG',
                singleDoc: 'documentTrainingSVG',
                scorm: 'InteractiveTrainingSVG',
                attest: 'AttestingSVG',
                new_training: 'TrainingSVG',
                document: 'documentTrainingSVG'

            }
        };
    },

    mounted() {
        
    },

    methods: {
        open() {
            this.showModal = true

            setTimeout(() => {
                this.clickOutsideEnabled = true
            }, 0)
        },
        close() {
            if (!this.clickOutsideEnabled) return
            this.showModal = false
            this.clickOutsideEnabled = false
        }
    },
};
</script>
<style lang="scss" scoped>
.create-modal{
    position: absolute;
    background: rgba(255, 255, 255, 0.7);
    padding: 33px 23px;
    border-radius: 1.6rem;
    background-blend-mode: overlay;
    box-shadow: 0px 33px 88px rgba(51, 29, 144, 0.22);
    backdrop-filter: blur(50px);
    max-width: 755px;
    right: 25%;
    z-index: 99;
}
.items{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.8rem;
}
.item{
    display: flex;
    flex-direction: column;
    width: 100%;
    flex: 1;
    min-width: 219px;
    height: 121px;
    font-size: 15px;
    padding: 17px;
    gap: 4px;
    border-radius: 1rem;
    outline: 2px solid #fff;
    justify-content: center;
    align-items: center;
    color: #17122C;
    cursor: pointer;
    overflow: hidden;

    transition: outline 0.3s, box-shadow 0.3s, background 0.3s;
    &:hover,&:active{

        background: rgba(217, 208, 255, 0.15);
        outline: 1px solid #624DE3;
        box-shadow: 0px 0px 4px #624DE3;

    }
}
.icon{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    width: 24px;
}
.title{
    font-weight: 600;
    font-family: 'Poppins', var(--main-site-font);
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>